import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '@/styles/tokens.css';
import '@/styles/tailwind.css';
import '@/styles/app.css';
import { router } from '@/app/router';
import { QueryProvider } from '@/app/providers/QueryProvider';
import { ToastProvider } from '@/app/providers/ToastProvider';
import { setOnUnauthorized } from '@/shared/api/client';

setOnUnauthorized(() => {
  if (!location.pathname.startsWith('/login') && !location.pathname.startsWith('/track')) {
    location.replace('/login');
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryProvider>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </QueryProvider>
  </StrictMode>,
);
